import { ref } from 'vue'

export const previousRoute      = ref({})

const backLocationStateKey = 'backLocation'

export function resolveBackLocation({ router, current, previous, state = {}, fallback }) {
    const normalize = (target) => {
        if (!target || (typeof target === 'string' && (!target.startsWith('/') || target.startsWith('//')))) return null
        try {
            const resolved = router.resolve(target)
            if (!resolved.matched.length || resolved.path === current.path || !current.params.tenantId
                || String(resolved.params.tenantId) !== String(current.params.tenantId)) return null

            return {
                path: resolved.path,
                query: resolved.query,
                hash: resolved.hash,
                state: { [backLocationStateKey]: target.state?.[backLocationStateKey] ?? null },
            }
        } catch {
            return null
        }
    }

    const remembered = state[backLocationStateKey]
    if (remembered?.path === current.path) {
        const restored = normalize(remembered.target)
        if (restored) return restored
    }

    const origin = normalize(previous?.fullPath)
    if (origin) {
        origin.state[backLocationStateKey] = remembered?.path === previous.path ? remembered : null
        return origin
    }

    const defaultLocation = normalize(fallback)
    if (defaultLocation && remembered?.path === defaultLocation.path) {
        defaultLocation.state[backLocationStateKey] = remembered
    }
    return defaultLocation ?? (fallback ? { ...fallback, state: { [backLocationStateKey]: null } } : null)
}

export function routeWithBackLocation(router, destination, backLocation) {
    return {
        ...destination,
        state: {
            ...destination.state,
            [backLocationStateKey]: { path: router.resolve(destination).path, target: backLocation },
        },
    }
}
